import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ConfigurationService} from '../../configuration.service';
import {UrlEndpoints} from '../../../definitions/url-endpoints';
import {CustomerModel} from '../../../models/customer.model';

@Injectable({
    providedIn: 'root'
})
export class CustomerResourceService {

    constructor(private http: HttpClient,
                private configuration: ConfigurationService,
                private urlEndpoints: UrlEndpoints) {
    }

    getCustomers() {
        return this.http.get(this.configuration.buildUrl(this.urlEndpoints.customerListByTstampEndPoint +
            this.configuration.getConfiguration().custDateTime)).toPromise();
    }

    getContacts() {
        return this.http.get(this.configuration.buildUrl(this.urlEndpoints.contactListByTstampEndPoint +
            this.configuration.getConfiguration().contactDateTime)).toPromise();
    }

    getOrders() {
        return this.http.get(this.configuration.buildUrl(this.urlEndpoints.orderListEndPoint +
            this.configuration.getConfiguration().selectedDepot)).toPromise();
    }

    getOrdersByCustomer(cust: CustomerModel) {
        return this.http.get(this.configuration.buildUrl(this.urlEndpoints.orderListCustomerEndPoint +
            cust.depot + '/' + cust.cod)).toPromise();
    }

    getContracts(custId: number) {
        return this.http.get(this.configuration.buildUrl(this.urlEndpoints.getLiveContractsForCustomerEndPoint) + custId).toPromise();
    }
}
